import { CanvasTexture, GLSL3, Mesh, PlaneGeometry, ShaderMaterial } from 'three';
import type { AnnotationLayer } from './annotations';
import vertexShader from './shaders/visitorName.vert?raw';
import fragmentShader from './shaders/visitorName.frag?raw';

export type TextSprite = Mesh<PlaneGeometry, ShaderMaterial>;

export function createTextSprite(
  canvas: HTMLCanvasElement,
  height: number,
  layer: AnnotationLayer,
  maxScreenWidthFraction = 0
): TextSprite {
  const material = new ShaderMaterial({
    glslVersion: GLSL3,
    vertexShader,
    fragmentShader,
    uniforms: {
      tName: { value: new CanvasTexture(canvas) },
      tGeom: layer.depth,
      uResolution: layer.resolution,
      uMaxWidthFraction: { value: maxScreenWidthFraction },
    },
    transparent: true,
    depthTest: false,
    depthWrite: false,
    toneMapped: false,
  });
  const sprite = new Mesh(new PlaneGeometry(1, 1), material);
  sprite.frustumCulled = false;
  sprite.scale.set((canvas.width / canvas.height) * height, height, 1);
  return sprite;
}

export function disposeTextSprite(sprite: TextSprite): void {
  const texture = sprite.material.uniforms.tName?.value as CanvasTexture | undefined;
  texture?.dispose();
  sprite.geometry.dispose();
  sprite.material.dispose();
}
